export default "__VITE_ASSET__CHigxeRT__"